import React from 'react';
import './EquipmentChoice.css';

const EquipmentChoice = () => {
  return (
    <div className="equipment-choice-page">
      <section className="choice-hero">
        <h1>Equipment Supply</h1>
        <p>Choose your transaction type</p>
      </section>

      <section className="choice-section">
        <div className="container">
          <div className="choice-grid">
            <div className="choice-card" onClick={() => window.location.href = '/equipment-purchase'}>
              <div className="choice-icon">📦</div>
              <h2>Equipment Purchase Order</h2>
              <p>For equipment acquisition, import, export and cross-border purchase transactions</p>
              <ul>
                <li>✓ Domestic & International Transactions</li>
                <li>✓ Purchase Order / LOI Confirmation</li>
                <li>✓ Full Documentation Support</li>
              </ul>
              <button className="choice-btn">Select Purchase</button>
            </div>

            <div className="choice-card" onClick={() => window.location.href = '/equipment-lease'}>
              <div className="choice-icon">📋</div>
              <h2>Equipment Leasing & Rental</h2>
              <p>For equipment lease, hire and rental transactions — domestic & international</p>
              <ul>
                <li>✓ Operating Lease / Rental</li>
                <li>✓ Finance Lease</li>
                <li>✓ Hire / Rental Options</li>
              </ul>
              <button className="choice-btn">Select Lease</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EquipmentChoice;